<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="lg"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Create Alternate Language Printable from <strong>ID: {{printable_to_link.id}} Title: {{printable_to_link.title}}</strong>
            </template>

            <div class="row align-items-center">
                <div class="col-lg-12 order-lg-1 order-2">
                    <b-form-group
                        class="mt-3"
                        label="Select Alternate Media Language"
                    >
                        <language-multiselect
                            v-model="selected_language"
                            :options="alternateLanguageOptions"
                            :multiple="false"
                            @add="addLanguage"
                            @remove="removeLanguage"
                        />
                        <b-form-invalid-feedback :state="!selected_language ? false : null">
                            Language is required before being able to select alternate media
                        </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                    >
                        <template v-slot:label>
                            <label>
                            New File (Optional) <sup><font-awesome-icon :icon="['fad', 'info-circle']" content="If no new file is provided, created printable will share url with original" class="text-secondary"  v-tippy="{placement: 'top'}" /></sup>
                            </label>
                        </template>
                        <b-form-file
                            v-model="new_file"
                            placeholder="Choose a file or drop it here..."
                            drop-placeholder="Drop file here..."
                        ></b-form-file>
                    </b-form-group>
                </div>
            </div>

            <template #modal-footer>
                <div v-if="!adding_printable">
                    <b-button
                        variant="primary"
                        @click="handleCreateAndLink()"
                        :disabled="validating()"
                    >
                        Create & Link Alternate Media
                    </b-button>
                </div>
                <div v-else>
                    <b-spinner small label="Linking..."></b-spinner>
                    Uploading & Linking New Media - This may take a few minutes
                </div>
                <b-button
                    variant="light"
                    @click="cancel"
                    :disabled="adding_printable"
                >
                    Cancel
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

import LanguageMultiselect from '@/components/LanguageMultiselect'

import languages from '@/common/languages'

export default {
    data: () => ({
        selected_language: null,
        languages: languages,
        adding_printable: false,
        new_file: null,
    }),
    props: [
        'printable_to_link',
        'printables_group',
        'value'
    ],
    components: {
        LanguageMultiselect
    },
    computed: {
        ...mapState({
        }),
        modal_id () {
            let modal_id = 'add-alternate-media-modal'
            return modal_id
        },
        alternateLanguageOptions() {
            return this.languages.filter(lang => lang.language !== this.printable_to_link.language);
        },
    },
    watch: {
        'printable_to_link.id': {
            handler(value) {
                // mark to remove once we have more than two languages
                this.setStartingSelectedLanguage();
            }
        },
    },
    methods: {
        validating(){
            return !(this.selected_language);
        },
        addLanguage(new_language){
            this.selected_language = new_language;
        },
        removeLanguage(){
            this.selected_language = null;
            this.resetForm();
        },
        resetForm() {
            this.new_file = null;
        },
        cancel (event) {
            event.preventDefault()
            this.resetForm();
            this.hide()
        },
        hide () {
            this.resetForm();
            this.$emit('hideCreateAlternate')
        },
        hidden () {
            this.$emit('hideCreateAlternate')
        },
        formattedLabel(option) {
            return `${option.id} - ${option.title}`;
        },
        getFlagIso(language) {
            const languageObject = this.languages.find(lang => lang.language === language);
            return languageObject ? languageObject.flag_iso : null;
        },
        findPrintableByLanguage(printablesArray, language) {
            return printablesArray.find(printable => printable.language === language);
        },
        getLanguageLabel(language) {
            const languageObject = this.languages.find(lang => lang.language === language);
            return languageObject ? languageObject.label : null;
        },
        addTag (tag, printable_id) {
            this.axios.post('/api/media/add_printable_tag/' + printable_id, {
                tag_id: tag.id
            })
        },
        async linkPrintableToGroup(new_printable_id) {
            this.axios.post('/api/media/link_printable_to_group/'+this.printable_to_link.id+'/'+new_printable_id+'/'+null)
            .then(response => {
                this.adding_printable = false;
                if(!response){
                    this.$bvToast.toast('An error has ocurred', {
                        title: 'Error',
                        variant: 'danger',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                }
                else{
                    this.$bvToast.toast('Printable was successfully linked', {
                        title: 'Success',
                        variant: 'success',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                    this.$emit('alternateAdded');
                    this.hide();               
                }
                
            }).catch(error => {
                if (error) {
                    this.adding_printable = false;
                    this.resetForm();
                }
            })
        },
        handleCreateAndLink() {
            const linkedPrintable = this.findPrintableByLanguage(this.printables_group, this.selected_language.language);
            if (linkedPrintable) {
                let message = `
                    <h4>Selected Printable already has ${this.selected_language.label} Printable linked</h4>
                    </br>
                    <p><strong>${this.printable_to_link.id} - ${this.printable_to_link.title} (${this.printable_to_link.language})</strong> 
                    is already linked to <strong>${linkedPrintable.id} - ${linkedPrintable.title} (${linkedPrintable.language})</strong>. Creating and linking a new alternate language will replace this printable with the 
                    newly created printable.  Do you wish to continue?</p>
                `
                this.$swal({
                    html: message,
                    showCancelButton: true,
                    confirmButtonText: 'Create & Link to new Printable',
                    confirmButtonColor: '#27AE60',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {               
                        this.createAndLinkNewPrintable()
                    }
                })
            } else {
                this.createAndLinkNewPrintable()
            }
        },
        createAltFileName(url, languageCode) {
            let fileName = url.split('/').pop();
            const [fileNameWithoutExtension, fileExtension] = fileName.split('.');
            return `${fileNameWithoutExtension}_${languageCode}.${fileExtension}`;
        },
        async createAndLinkNewPrintable() {
            this.adding_printable = true;

            let file = null;
            let form_data = new FormData();
            if (this.new_file) {
                file = this.new_file;
            }

            let new_title = `${this.printable_to_link.title} - ${this.selected_language.label} Version`

            let merlin_id_array = [];
            // format comma separated merlin_ids input into an array, only accept numbers
            if (this.printable_to_link.merlin_ids) {
                merlin_id_array = this.printable_to_link.merlin_ids
                    .split(',')
                    .map((id) => parseInt(id.trim(), 10))
                    .filter((id) => !isNaN(id));
            }
            // if no file is provided and the printable has a cdn_url, we will have the new printable share the cdn_url of original
            if (!file && this.printable_to_link.cdn_url) form_data.append('cdn_url', `${this.printable_to_link.cdn_url}?lang=${this.selected_language.language}`);
            form_data.append('file', file);
            form_data.append('title', new_title);
            form_data.append('language', this.selected_language.language);
            if (merlin_id_array.length > 0) form_data.append('merlin_ids', merlin_id_array);


            this.axios.post('/api/media/upload_new_alt_printable/', form_data)
            .then(response => {
                if(!response){
                    this.$bvToast.toast('An error has ocurred', {
                        title: 'Error',
                        variant: 'danger',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                    this.adding_printable = false;
                }
                else{
                    this.$bvToast.toast('Printable was successfully uploaded', {
                        title: 'Success',
                        variant: 'success',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                    if (response.data.worksheet_id) {
                        if (this.printable_to_link.tags && this.printable_to_link.tags.length > 0) {
                            for (let tag of this.printable_to_link.tags) {
                                this.addTag(tag, response.data.worksheet_id)
                            }
                        }
                    }
                    this.linkPrintableToGroup(response.data.worksheet_id)
                }              
            }).catch(error => {
                if (error) {
                    this.adding_printable = false;
                    this.resetForm();
                }
            })
        },
        setStartingSelectedLanguage() {
            // This function just sets the selected language based on the printable_to_link language and is only needed while we have two languages (en & es)
            // once more languages are added we don't need to do this check, as you will want select beteween multiple languages in the select language dropdown
            if (this.printable_to_link.language === 'es') {
                this.selected_language = {
                    language: 'en',
                    label: 'English',
                    flag_iso: 'us'
            }
            } else if (this.printable_to_link.language === 'en') {
                this.selected_language = {
                    language: 'es',
                    label: 'Spanish',
                    flag_iso: 'es'
                }
            }
        },
        
    },
    mounted () {
        // mark to remove once we have more than two languages
        this.setStartingSelectedLanguage();
        
        
    },
    
}

</script>
